// extracted by mini-css-extract-plugin
module.exports = {"tick":"Tick_tick__1ODtg"};